import React, { useCallback, useState } from 'react';
import LoadedDataTable from '../../../Elements/DataTable/LoadedDataTable';
import DemoListItem from './DemoListItem';
import { DEMO_SHOPS } from './demoListData';

function LoadedDataTableDemoComponent() {
  const [isEmpty, setIsEmpty] = useState(false);
  // Stands in for a service call: an in-memory answer, so nothing reaches the backend.
  const loadShops = useCallback(() => Promise.resolve(isEmpty ? [] : DEMO_SHOPS.slice(0, 5)), [isEmpty]);

  return (
    <div>
      <div className='dsg-row'>
        <button
          type='button'
          className='btn'
          onClick={() => setIsEmpty(!isEmpty)}
        >
          <i className='fa-solid fa-rotate' /> {isEmpty ? 'Load five shops' : 'Load an empty list'}
        </button>
      </div>
      <LoadedDataTable
        load={loadShops}
        failureMessage='Error! ErrorCode: DSG401. Failed to load the demo shops.'
        type={DemoListItem}
        emptyMessage='There are no demo shops.'
      />
    </div>
  );
}

export const loadedDataTableDemo = {
  id: 'loaded-data-table',
  title: 'Loaded list (LoadedDataTable)',
  category: 'Lists & Grids',
  importPath: 'Elements/DataTable/LoadedDataTable',
  notes: [
    'A read-only list the backend sends whole, in one call, such as a tab of a detail popup: no paging, sorting or search, unlike TabOfDataTable.',
    'load returns the call’s promise; wrap it in useCallback with the values it depends on, as the list loads again whenever load changes (Helpers/useBackendData).',
    'Shows the loading indicator, then the backend’s { error } refusal or the rows, each made into an item of type (a Domain item class), or emptyMessage when there are none.',
    'Row actions work as on any list: the Domain item’s action column calls a static function that the page binds.',
  ],
  snippet:
    "const loadRuns = useCallback(() => InvoiceAutomationService.GetInvoiceAutomationRuns(projectId), [projectId]);\n\n<LoadedDataTable\n  load={loadRuns}\n  failureMessage='Error! ErrorCode: XX12. Failed to load the runs.'\n  type={InvoiceAutomationRunItem}\n  emptyMessage='The automation has not run yet.'\n/>",
  render: LoadedDataTableDemoComponent,
};
